/* eslint-disable @typescript-eslint/no-empty-function */
import { ApolloQueryResult } from '@apollo/client';
import { ContextInput } from '@shared-ui/bex-api-context/dist/commonjs/types';
import debounce from 'lodash.debounce';
import { CategorizedResults, CategoryMap, ESSResponse, TypeaheadAdapter, TypeaheadResult } from 'uitk-react-typeahead';

interface SearchBoxTypeaheadAdapterConfigs {
  maxResults: number;
  refetchResults: () => Promise<ApolloQueryResult<unknown>>;
  context: Partial<ContextInput>;
  hubId: string;
}

export class ElasticSearchAdapter implements TypeaheadAdapter {
  private results: Array<TypeaheadResult>;
  private readonly categories: CategoryMap = {};

  constructor(private readonly config?: SearchBoxTypeaheadAdapterConfigs) {
    this.results = [];
  }

  onItemSelection(data: object): Promise<object> {
    return Promise.resolve(data);
  }

  getResults() {
    return this.results;
  }

  async fetchResponse(): Promise<ESSResponse> {
    return Promise.resolve({ sr: [] });
  }

  adaptResponseToTypeaheadResults(): TypeaheadResult[] {
    return new Array<TypeaheadResult>();
  }

  async fetchResults(term: string): Promise<TypeaheadResult[] | CategorizedResults[]> {
    this.results = [];
    if (term) {
      await new Promise((resolve) => {
        fetchSearchResults(term, this.config, (results) => {
          this.results = results;
          resolve(this.results);
        });
      });
    }
    return this.results;
  }

  async fetchResultsCategorized(): Promise<CategorizedResults[]> {
    throw new Error('Method not implemented.');
  }

  fetchRecentSearchResults(): Promise<TypeaheadResult[] | CategorizedResults[]> {
    throw new Error('Method not implemented.');
  }

  fetchRecentSearchResultsCategorized(): Promise<CategorizedResults[]> {
    throw new Error('Method not implemented.');
  }

  fetchAlternativeResults(): Promise<TypeaheadResult[] | CategorizedResults[]> {
    return Promise.resolve([]);
  }

  logResponse(results: unknown): Promise<unknown> {
    // console.debug('Search box response', results);
    return Promise.resolve(results);
  }

  typeaheadDialogOpened() {}

  logSuggestionShown() {}

  logTypeaheadDismiss(): void {}

  setTypeaheadCategories(): void {}

  getTypeaheadCategories(): CategoryMap {
    return this.categories;
  }
}

async function search(documents) {
  return documents?.map((matchingDocument) => {
    return {
      name: `<div class="search-result-location">${matchingDocument.parentTitles}</div>`,
      title: matchingDocument.title,
      value: matchingDocument.path,
      icon: null,
      subtext: `<span class="search-result-title">${matchingDocument.title}</span>: ${matchingDocument.intro || ''}`,
    } as TypeaheadResult;
  });
}
const fetchSearchResults = debounce(async (term, config, updateResultsCb) => {
  const { data } = await config.refetchResults({
    searchTerm: term,
    context: config.context,
    hubId: config.hubId,
  });
  if (data.documentation.search.searchResults?.length) {
    const results = await search(data.documentation.search.searchResults);
    updateResultsCb(results);
  }
}, 1000);
